
import React from 'react';
import LabelledInput from '~components/atoms/LabelledInput';
import { useAppSelector } from '~redux/hooks';
import { MetalTypeEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as FormStyles from './DetailsFormCustomerTransferModal.module.scss';
import SummaryPDF from './SummaryPDF';
import ReceiptPDF from './ReceiptPDF';

const DetailsFormCustomerTransferModal = () => {
    const { Misc: { dateTimeFormat } } = UtilFunctions;
    
    const customerTransferDetails = useAppSelector(state => state.customerTransfer.customerTransferDetails);

    const formatWeight = (weight?: number | null) => weight != null ? Number(weight).toFixed(3) : '';

    return (
        <div className={FormStyles.container}>
            <div className={FormStyles['form-container']}>

                <LabelledInput
                    id='senderName'
                    name='senderName'
                    label='Sender Name*:'
                    value={customerTransferDetails.senderName ?? ''}
                    disabled
                    className={FormStyles['span-2']}
                />

                <LabelledInput
                    id='senderIdNo'
                    name='senderIdNo'
                    label='Sender ID Number*:'
                    value={customerTransferDetails.senderIdNo ?? ''}
                    disabled
                />

                <LabelledInput
                    id='senderCIFNo'
                    name='senderCIFNo'
                    label='Sender CIF No.*:'
                    value={customerTransferDetails.senderCIFNo ?? ''}
                    disabled
                />

                <LabelledInput
                    id='branchName'
                    name='branchName'
                    label='Branch*:'
                    value={customerTransferDetails.branchName ?? ''}
                    disabled
                />

                <LabelledInput
                    id='branchCode'
                    name='branchCode'
                    label='Branch Code*:'
                    value={customerTransferDetails.branchCode ?? ''}
                    disabled
                />

                <LabelledInput
                    id='region'
                    name='region'
                    label='Region*:'
                    value={customerTransferDetails.regionName ?? ''}
                    disabled
                    className={FormStyles['span-2']}
                />

                <LabelledInput
                    id='metalType'
                    name='metalType'
                    label='Metal Type*:'
                    value={
                        customerTransferDetails.metalType != null
                            ? MetalTypeEnum[customerTransferDetails.metalType] ?? ''
                            : ''
                    }
                    disabled
                />

                <div />

                <LabelledInput
                    id='productName'
                    name='productName'
                    label='Product*:'
                    value={customerTransferDetails.productName ?? ''}
                    disabled
                />

                <LabelledInput
                    id='weight'
                    name='weight'
                    label='Total Weight (g)*:'
                    value={formatWeight(customerTransferDetails.weight)}
                    disabled
                />

                <div />

                <LabelledInput
                    id='receiverName'
                    name='receiverName'
                    label='Receiver Name*:'
                    value={customerTransferDetails.receiverName ?? ''}
                    disabled
                    className={FormStyles['span-2']}
                />

                <LabelledInput
                    id='receiverIdNo'
                    name='receiverIdNo'
                    label='Receiver ID Number*:'
                    value={customerTransferDetails.receiverIdNo ?? ''}
                    disabled
                />

                <LabelledInput
                    id='receiverCIFNo'
                    name='receiverCIFNo'
                    label='Receiver CIF No.*:'
                    value={customerTransferDetails.receiverCIFNo ?? ''}
                    disabled
                />

                <LabelledInput
                    id='branchTellerName'
                    name='branchTellerName'
                    label='Branch Teller Name:'
                    value={customerTransferDetails.branchTellerName ?? ''}
                    disabled
                />

                <LabelledInput
                    id='referralName'
                    name='referralName'
                    label='Referral Name:'
                    value={customerTransferDetails.referralName ?? ''}
                    disabled
                />

                <LabelledInput
                    id='salesPersonnelName'
                    name='salesPersonnelName'
                    label='Sales Personnel Name:'
                    value={customerTransferDetails.salesPersonnelName ?? ''}
                    disabled
                />

                <LabelledInput
                    id='createdAt'
                    name='createdAt'
                    label='Transaction Date:'
                    value={dateTimeFormat(customerTransferDetails.createdAt) ?? ''}
                    disabled
                />

            </div>

            <div className={FormStyles['button-container']}>
                <div className={FormStyles['button-container']}>
                    <SummaryPDF />

                    <ReceiptPDF />
                </div>
            </div>
        </div>
    );
};

export default DetailsFormCustomerTransferModal;
